<template>
  <div class="donationIndex" v-show="donationIndexShow">
    <!-- 页面顶部图片 -->
    <div class="head_img">
      <img src="./../../../assets/images/activity/donationActive/indexBg0216.png" alt="">
      <div class="FHlogo" v-if="!channelName"></div>
      <div class="channelLogo" v-if="channelName"><img :src='"https://image-mom.feihe.com/channelNewLogos/"+pageSource+".png"' alt=""></div>
    </div>
    <div class="explain_box">
      <!-- 公益活动说明 -->
      <div class="explain">
        <div class="ex_tit">公益活动说明：</div>
        <p>亿起战疫 “鹤”护新生<br />中国飞鹤免费为全国孕产妈妈捐助飞鹤“星蕴孕产妇奶粉”（一人两罐），疫期提升妈妈抵抗力，助力全国孕妈好营养！ <br />公益合作单位：中国红十字基金会<br />活动时间：2020年2月14日—2020年3月4日</p>
      </div>
      <!-- 申领规则说明 -->
      <div class="explain">
        <div class="ex_tit">捐赠申领说明：</div>
        <p>1、申领请进入“飞鹤星妈会”微信公众号，点击链接进行信息登记，申领即同意相关个人信息采集。<br /> 2、每位符合条件的孕产妈妈只能申领一次，每天申领上限10000人，分别为每日上午9点、下午15点各开放5000人，达到上限后，用户信息无法提交。先到先得！<br /> 3、为了保证信息准确性本次申领活动个人信息与收货信息一旦提交不能修改，如信息有误，将视同放弃申领。<br />4、申领信息将于1-5个工作日内进行审核并反馈，对符合申领标准的，我们将根据对应地址安排物流，受疫情影响，预计2月20日至3月26日陆续发出，物流信息可在“飞鹤星妈会“公众号→个人中心→我的订单中查看。<br />5、受疫情影响，物流时间有可能会较长，我们也将以最大的努力尽快送达。<br />非常感谢支持与理解！</p>
      </div>
    </div>
    <!-- 免费申领奶粉 -->
    <div class="receive_btn" @click="toUserInfo">立即申领奶粉</div>
    <!-- 分享按钮 -->
    <div class="share_btn" @click="shareFn"></div>
    <!-- 分享关注引导 -->
    <share-guide ref="shareGuide"></share-guide>
    <!-- 加载中 -->
    <div class="submit_loading" v-show="pageLoading">
      <van-loading type="spinner" size="50px" color="#ffffff" vertical></van-loading>
    </div>
  </div>
</template>

<style lang="less" scoped>
.donationIndex {
  width: 100%;
  background-color: RGBA(255, 233, 31, 1);
  background-image: url(./../../../assets/images/activity/donationActive/mask1.png);
  background-position: bottom center;
  background-repeat: no-repeat;
  background-size: 100% auto;
  overflow: hidden;
  // 页面顶部图片
  .head_img {
    width: 100%;
    position: relative;
    padding-top: 10px;
    overflow: hidden;
    img {
      width: 100%;
      float: left;
    }
    div.FHlogo {
      width: 180px;
      height: 28px;
      background: url(../../../assets/images/activity/donationActive/logo.png)
        no-repeat center center;
      background-size: auto 100%;
      position: absolute;
      top: 30px;
      left: 35px;
    }
    .channelLogo {
      height: 51px;
      position: absolute;
      top: 20px;
      left: 0;
      right: 0;
      margin: auto;
      text-align: center;
      img {
        width: auto;
        height: 51px;
        float: none;
      }
    }
  }
  // 公益活动说明
  .explain_box {
    background-image: url(./../../../assets/images/activity/donationActive/mask.png);
    background-position: center -35px;
    background-repeat: no-repeat;
    background-size: 100% auto;
    overflow: hidden;
    padding-bottom: 83px;
  }
  .explain {
    float: left;
    margin: 26px 14px 0;
    background: rgba(255, 253, 241, 1);
    border-radius: 30px;
    padding: 61px 27px 34px;
    overflow: hidden;
    position: relative;
    .ex_tit {
      width: 156px;
      height: 37px;
      padding-left: 43px;
      background-color: rgba(245, 129, 175, 1);
      background-image: url(./../../../assets/images/activity/donationActive/xing.png);
      background-position: 10px center;
      background-repeat: no-repeat;
      background-size: 30px auto;
      border-top-right-radius: 30px;
      border-bottom-right-radius: 30px;
      font-size: 18px;
      font-weight: bold;
      color: rgba(255, 255, 255, 1);
      line-height: 37px;
      position: absolute;
      top: 0;
      left: 0;
    }
    p {
      font-size: 14px;
      font-weight: bold;
      color: rgba(110, 53, 23, 1);
      line-height: 30px;
    }
  }

  // 免费申领奶粉
  .receive_btn {
    width: 286px;
    height: 51px;
    background: linear-gradient(
      -90deg,
      rgba(32, 61, 171, 1),
      rgba(39, 76, 213, 1)
    );
    border-radius: 10px;
    text-align: center;
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: rgba(255, 255, 255, 1);
    line-height: 51px;
    position: fixed;
    bottom: 5px;
    left: 0;
    right: 0;
    margin: auto;
  }
  .share_btn {
    width: 66px;
    height: 66px;
    position: fixed;
    bottom: 75px;
    right: 5px;
    background-image: url(./../../../assets/images/activity/donationActive/share.png);
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 100%;
    border-radius: 50%;
  }

  // 正在提交中
  .submit_loading {
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 9999;
    .van-loading {
      width: 140px;
      height: 150px;
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
      color: #ffffff;
    }
    .van-loading__text {
      font-size: 18px;
      color: #ffffff;
    }
  }

  @media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
    .receive_btn {
      bottom: 13px;
    }
  }
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 2) {
    .receive_btn {
      bottom: 13px;
    }
  }
  @media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
    .receive_btn {
      bottom: 13px;
    }
  }
}
</style>


<script>
import { getCookie, is_weixin } from '@/assets/js/common.js';
import API from "@/utils/axiosApi/donationApi";
/**
 * 新增Api接口
 */
import YAPI from "@/utils/axiosApi/donationApi";
import wxJsSet from './../../../assets/js/DonatewxConfig.js';
import channelData from './../../../utils/mockData/channelData';
import shareGuide from "@/components/activity/donation_active/shareGuide.vue";
export default {
  name: "donationIndex",
  components: {
    shareGuide
  },
  data () {
    return {
      donationIndexShow: false,
      channelName: null,//渠道名称带logo的微信渠道
      pageSource: null, //页面来源
      pageSourceName: null,//页面来源名称
      isWeixin: null,
      isFullToast: false,
      isSubmit: false,
      pageLoading: false
    };
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
      if (vm.is_weixin()) {//微信中
        if (vm.getCookie("xmh_openid") == null || vm.getCookie("xmh_openid") == "") {//判断有没有openId
          location.href = "/xmh/v2/wechat/oauth2/authorize?url=" + encodeURIComponent(window.location.href);
        } else {
          vm.donationIndexShow = true;
        }
      } else {
        vm.donationIndexShow = true;
      }
    })
  },
  mounted () {
    var shareLink = location.origin + "/donationMilk";
    if (this.$route.query.pageSource) {
      this.pageSource = this.$route.query.pageSource;
      this.channelName = channelData.channelLogoList[this.pageSource];
      this.pageSourceName = this.channelName || channelData.channelNoLogoList[this.pageSource];
      if (this.pageSource.indexOf("_wx") !== -1) {
        this.isWeixin = "weixin";
      }
      shareLink = location.origin + "/donationMilk?pageSource=" + this.pageSource;
    }
    var that = this;
    var shareDataParams = {
      shareLink: shareLink,
      shareDesc: '中国飞鹤累计捐赠2亿元款物。点击领取',
      shareTitle: '飞鹤直送一亿奶粉，孕妈领取专属免疫力',
      imgUrl: "https://image-mom.feihe.com/wxshare/donation.png",//必须是绝对路径
      shareSuccess: function () {
        that.$toast({
          duration: 2000,
          message: '分享成功'
        })
      }
    }
    wxJsSet.wxShare(this, shareDataParams);

    this.pageSourceName = this.pageSourceName ? this.pageSourceName : "星妈会";
    gio('page.set', { 'pageSource': this.pageSourceName });
  },
  methods: {
    // 跳转到填写信息
    toUserInfo: function () {
      this.pageLoading = true;
      this.$http.get("/donate/check/" + this.getCookie("xmh_openid"), {}, res => {
        if (res.code == "200") {
          this.pageLoading = false;
          // 不到9点的时候提示“9点限量开放，先到先得”
          // if(new Date().getHours()<9){
          //   this.$toast({
          //     duration:4000,
          //     message:'9点限量开放，先到先得！'
          //   })
          // }else if(new Date().getHours()>=9 && new Date().getHours()<15){ //9点到下午15点
          //   this.checkCount("今日上午已达上限，信息无法提交。\n下午15点限量开放，先到先得！");
          // }else{
          //   this.checkCount("您好，申领活动已结束");
          // }
          this.$toast({
            duration: 4000,
            message: '您好，申领活动已结束'
          })
        } else if (res.code == "201" || res.code == "202" || res.code == "203" || res.code == "204") {
          this.pageLoading = false;
          this.goInfo()
        } else {
          this.pageLoading = false;
          this.$toast({
            duration: 2000,
            message: '活动太火爆了，请稍后重试。'
          })
        }
      }, error => {
        this.pageLoading = false;
        this.$toast({
          duration: 2000,
          message: '活动太火爆了，请稍后重试。'
        })
      })
    },
    checkCount (message) {
      // 9点之后
      YAPI.countMember({}, res => {
        if (!res.data) {
          this.$toast({
            duration: 4000,
            message: message
          })
        } else {
          this.goInfo()
        }
      }, error => {
        this.$toast({
          duration: 2000,
          message: '活动太火爆了，请稍后重试。'
        })
      })
    },
    goInfo () {
      gio('track', 'donationmilk_gotoapply', { "pageSource_var": this.pageSourceName, "isWeixin": this.isWeixin });
      var that = this;
      setTimeout(function () {
        if (that.pageSource) {
          location.href = "/donationMilk/userInfo?pageSource=" + that.pageSource;
        } else {
          location.href = "/donationMilk/userInfo";
        }
      }, 200);
    },
    // 点击分享按钮
    shareFn () {
      this.$refs.shareGuide.showShare();
    }
    , getCookie, is_weixin
  },

};
</script>
